<template>
  <div id="app">
    <Header/>
    <router-view/>
    <Footer/>
    <!--    <LocationConfirm/>-->
    <!--    <LocationAddress/>-->
    <!--    <OutsideCountry/>-->
    <NearestPharmacy/>
    <ThereIsNoDrugStores/>
    <CardAlreadyExist/>
    <PhoneAlreadyExist/>
    <CardDoesntExist/>
    <CardDoesntFind/>
    <Hotline/>
        <info/>
    <Cookies/>

  </div>
</template>

<script>
import {mapActions, mapMutations, mapGetters} from "vuex";
import Header from "@/components/global/Header";
import Footer from "@/components/global/Footer";
import LocationConfirm from "@/components/modals/LocationConfirm";
import LocationAddress from "@/components/modals/LocationAddress";
import OutsideCountry from "@/components/modals/OutsideCountry";
import NearestPharmacy from "@/components/modals/NearestPharmacy";
import ThereIsNoDrugStores from "@/components/modals/ThereIsNoDrugStores";
import CardAlreadyExist from "@/components/modals/CardAlreadyExist";
import PhoneAlreadyExist from "@/components/modals/PhoneAlreadyExist";
import CardDoesntExist from "@/components/modals/CardDoesntExist";
import CardDoesntFind from "@/components/modals/CardDoesntFind";
import Hotline from "@/components/modals/Hotline";
import Cookies from "@/components/modals/Cookies";
import info from "@/components/modals/info.vue";

export default {
  data() {
    return {};
  },
  components: {
    Header,
    Footer,
    LocationConfirm,
    LocationAddress,
    OutsideCountry,
    NearestPharmacy,
    Hotline,
    Cookies,
    ThereIsNoDrugStores,
    PhoneAlreadyExist,
    CardAlreadyExist,
    CardDoesntExist,
    CardDoesntFind,
    info
  },
  computed: {
    ...mapGetters([
      "getGoogleApiKey",
      "getUserLocation",
      'getHideMap',
      'getGoogle',
      'getMapMarkers',
      'getCurrentCoordinates',
      "getConvertedToTempMapMarkers",

      'getOpenMarkerOnMap'
    ]),
  },

  watch: {

    'getUserLocation'() {
      let userLocation = JSON.parse(localStorage.getItem("userLocation"));
      if (userLocation !== null) {
        this.getDrugStores(
          "",
          "",
          "",
          userLocation.lat,
          userLocation.lng,
          10000,
          false
        );
      }
    },
    'getMapMarkers'() {
      this.initializeMap();
      this.showMapBlock(false)
    },
    'getHideMap'(to, from) {
      if (to === false) {
        this.setGoogleMapApi().then(() => {
          var сonfirmedLocation = JSON.parse(localStorage.getItem("userLocation"));

          if (!сonfirmedLocation) {
            this.setLocationConfirmModal(true);

            if (navigator.geolocation) {
              navigator.geolocation.getCurrentPosition(
                (position) => {
                  let coordinates = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                  };
                  localStorage.geolocationOpened = true;
                  this.setGeolocationOpened(true);
                  this.getUserLocationByLatLng({coordinates, position}).then(
                    () => {
                      this.checkCountry(this.getUserLocation.country);
                    }
                  )
                },
                () => {
                  localStorage.geolocationOpened = false;
                  this.setGeolocationOpened(false);
                  this.getUserPositionByIP().then(() => {
                    this.checkCountry(this.getUserLocation.country);
                  })
                }
              );
            }
          } else {
            this.checkCountry(сonfirmedLocation.country);
            this.$store.commit("setUserLocation", {
              coordinates: {
                lat: сonfirmedLocation.lat,
                lng: сonfirmedLocation.lng,
              },
              cityName: сonfirmedLocation.city,
              countryName: сonfirmedLocation.country,
            });


          }
        });
      }
    }
  },

  methods: {
    ...mapActions([
      "setGoogleMapApi",
      "getUserPositionByIP",
      "getUserLocationByLatLng",
      "showMapBlock"
    ]),
    ...mapMutations([
      "setInfoPopUp",
      "setLocationConfirmModal",
      "setLocationAddressModal",
      "convertToTempMapMarkers",
      "setOutsideCountryModal",
      "setResponsive",
      "setGeolocationOpened",
      "showThereIsNoDrugStoresGoAway",
      "setMapMarkers",
    ]),

    async getDrugStores(Address, Letter, City, Lat, Lon, Radius, workAround) {
      var data = new FormData();
      data.append("Address", Address);
      data.append("Letter", Letter);
      data.append("City", City);
      data.append("Lat", Lat);
      data.append("Lon", Lon);
      data.append("Radius", Radius);
      data.append("WorkAround", workAround);

      await this.axios
        .post(
          "https://terapia-plus-api.azurewebsites.net/api/Map/getDrugStores",
          data
        )
        .then((res) => {
          this.drugStores = res.data;
          this.convertToTempMapMarkers(this.drugStores);
          var tempMapMarkers = this.getConvertedToTempMapMarkers;
          if (Radius == 0 && tempMapMarkers.length !== 0) {
            var t = tempMapMarkers[0];
            tempMapMarkers = [];
            tempMapMarkers.push(t);
          }
          if (tempMapMarkers.length == 0) {
            this.showThereIsNoDrugStoresGoAway(true);
          } else {
            this.setMapMarkers(tempMapMarkers);
          }
          this.displayLoader = false;
        });
    },

    checkCountry(country) {
      if (country !== undefined && country !== "UA") {
        this.setOutsideCountryModal(true);
        this.setLocationConfirmModal(false);

        this.$store.commit("setUserLocation", {
          coordinates: {
            lat: 50.45,
            lng: 30.52,
          },
          cityName: "Kiev",
          countryName: "UA",
        });
      } else {
        this.setOutsideCountryModal(false);
      }
    },

    createPopupClass() {
      var google = this.google;

      function Popup(position, marker) {
        this.position = position;

        var div = document.createElement("div");
        div.classList.add("map-popup");
        div.classList.add("popup-bubble");

        var close = document.createElement("div");
        close.classList.add("map-popup__close");
        close.addEventListener("click", e => {
          var containerDiv = e.target.closest(".popup-container");
          if (containerDiv) {
            containerDiv.parentNode.removeChild(containerDiv);
          }
        });

        // Create element for name
        var name = document.createElement("div");
        name.classList.add("map-popup__name");
        name.textContent = marker.title;

        // Create element for address
        var address = document.createElement("div");
        address.classList.add("map-popup__address");
        address.textContent = marker.city + ", " + marker.address;

        // Create element for phones
        var phones = document.createElement("div");
        phones.classList.add("map-popup__phones");

        marker.phones.forEach(phoneNumber => {
          var phone = document.createElement("a");
          phone.classList.add("map-popup__phone");
          phone.textContent = phoneNumber;
          phone.href = "tel:" + phoneNumber;
          phones.appendChild(phone);
        });

        // Create element for phone
        var timeWork = document.createElement("div");
        timeWork.classList.add("map-popup__timeworks");

        var weekdays = document.createElement("div");
        weekdays.classList.add("map-popup__timeworks-item");
        weekdays.textContent = marker.timeWork.weekdays;
        timeWork.appendChild(weekdays);

        var weekend = document.createElement("div");
        weekend.classList.add("map-popup__timeworks-item");
        weekend.textContent = marker.timeWork.weekend;
        timeWork.appendChild(weekend);

        // Create element for link
        var link = document.createElement("a");
        link.classList.add("map-popup__link");
        link.textContent = "Прокласти маршрут";
        link.target = "_blank";
        // var coordinates = this.getCurrentCoordinates;
        link.href =
          "https://www.google.com/maps/dir/" +
          marker.position.lat +
          "," +
          marker.position.lng;

        // Begin append elements to container
        div.appendChild(close);
        div.appendChild(name);
        div.appendChild(address);
        div.appendChild(phones);
        div.appendChild(timeWork);
        div.appendChild(link);

        // This zero-height div is positioned at the bottom of the bubble.
        var bubbleAnchor = document.createElement("div");
        bubbleAnchor.classList.add("popup-bubble-anchor");
        bubbleAnchor.appendChild(div);

        // This zero-height div is positioned at the bottom of the tip.
        this.containerDiv = document.createElement("div");
        this.containerDiv.classList.add("popup-container");
        this.containerDiv.appendChild(bubbleAnchor);

        // Optionally stop clicks, etc., from bubbling up to the map.
        google.maps.OverlayView.preventMapHitsAndGesturesFrom(
          this.containerDiv
        );
      }

      Popup.prototype = Object.create(google.maps.OverlayView.prototype);
      Popup.prototype.onAdd = function () {
        this.getPanes().floatPane.appendChild(this.containerDiv);
      };
      Popup.prototype.onRemove = function () {
        if (this.containerDiv && this.containerDiv.parentNode) {
          this.containerDiv.parentNode.removeChild(this.containerDiv);
        }
      };
      Popup.prototype.draw = function () {
        var divPosition = this.getProjection().fromLatLngToDivPixel(
          this.position
        );
        var display =
          Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000
            ? "block"
            : "none";

        if (display === "block") {
          this.containerDiv.style.left = divPosition.x - 200 + "px";
          this.containerDiv.style.top = divPosition.y + "px";
        }
        if (this.containerDiv.style.display !== display) {
          this.containerDiv.style.display = display;
        }
      };
      return Popup;
    },

    initializeMap() {
      this.google = this.getGoogle;
      if (this.google) {
        const mapContainer = document.getElementById('global-map');
        const bounds = new this.google.maps.LatLngBounds();
        this.map = new this.google.maps.Map(mapContainer, {
          styles: [
            {
              featureType: "administrative",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#444444"
                }
              ]
            },
            {
              featureType: "administrative.locality",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#378b90"
                }
              ]
            },
            {
              featureType: "administrative.neighborhood",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#31b9c1"
                }
              ]
            },
            {
              featureType: "landscape",
              elementType: "all",
              stylers: [
                {
                  color: "#f2f2f2"
                }
              ]
            },
            {
              featureType: "poi",
              elementType: "all",
              stylers: [
                {
                  visibility: "off"
                }
              ]
            },
            {
              featureType: "road",
              elementType: "all",
              stylers: [
                {
                  saturation: -100
                },
                {
                  lightness: 45
                }
              ]
            },
            {
              featureType: "road.highway",
              elementType: "all",
              stylers: [
                {
                  visibility: "simplified"
                }
              ]
            },
            {
              featureType: "road.arterial",
              elementType: "labels.icon",
              stylers: [
                {
                  visibility: "off"
                }
              ]
            },
            {
              featureType: "transit",
              elementType: "all",
              stylers: [
                {
                  visibility: "off"
                }
              ]
            },
            {
              featureType: "water",
              elementType: "all",
              stylers: [
                {
                  color: "#46bcec"
                },
                {
                  visibility: "on"
                }
              ]
            },
            {
              featureType: "water",
              elementType: "geometry.fill",
              stylers: [
                {
                  color: "#31b9c1"
                }
              ]
            },
            {
              featureType: "water",
              elementType: "geometry.stroke",
              stylers: [
                {
                  color: "#31b9c1"
                }
              ]
            }
          ],
          zoom: 8,
          // ukraine location by default
          center: {
            lat: JSON.parse(localStorage.getItem("userLocation")).lat,
            lng: JSON.parse(localStorage.getItem("userLocation")).lng
          },
          disableDefaultUI: true
        });
        if (this.getMapMarkers.length !== 0) {
          var Popup = this.createPopupClass(this.google);
          var popup = null;
          var markers = [];
          var markerDefault = null;
          var activeMarker = null;
          var location = null;
          var first = true;
          this.getMapMarkers.forEach(marker => {
            // marker icons
            markerDefault = {
              url:
                "data:image/png;base64,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",
              scaledSize: new this.google.maps.Size(36, 36), // scaled size
              origin: new this.google.maps.Point(0, 0), // origin
              anchor: new this.google.maps.Point(0, 0) // anchor
            };
            activeMarker = {
              url:
                "data:image/png;base64,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",
              scaledSize: new this.google.maps.Size(36, 36), // scaled size
              origin: new this.google.maps.Point(0, 0), // origin
              anchor: new this.google.maps.Point(0, 0) // anchor
            };

            // set marker location
            location = new this.google.maps.LatLng(
              marker.position.lat,
              marker.position.lng
            );

            // create marker
            var currentMarker = new this.google.maps.Marker({
              position: marker.position,
              marker: marker,
              map: this.map,
              animation: null,
              icon: markerDefault
            });
            markers.push(currentMarker);

            // add listener for marker
            currentMarker.addListener("click", () => {
              // set marker on click
              markers.forEach(m => {
                m.setIcon(markerDefault);
              });

              currentMarker.setIcon(activeMarker);
              // translate to center map by marker coordinates
              this.map.panTo(
                new this.google.maps.LatLng(
                  currentMarker.position.lat(),
                  currentMarker.position.lng()
                )
              );
              //  create custom popup
              if (popup) {
                popup.setMap(null);
              }
              popup = new Popup(
                new this.google.maps.LatLng(
                  marker.position.lat,
                  marker.position.lng
                ),
                marker
              );
              popup.setMap(this.map);
            });
            if (
              first &&
              this.getMapMarkers.length == 1 //||
              // (this.getOpenMarkerOnMap && first)
            ) {
              new this.google.maps.event.trigger(currentMarker, "click");
              //              this.setOpenMarkerOnMap(false);
              first = false;
            }
            bounds.extend(location);
            this.map.fitBounds(bounds);
            this.map.panToBounds(bounds);
          });
        } else {
          new this.google.maps.Marker({
            position: {
              lat: JSON.parse(localStorage.getItem("userLocation")).lat,
              lng: JSON.parse(localStorage.getItem("userLocation")).lng
            },
            map: this.map
          });
        }
        this.map.setCenter({
          lat: JSON.parse(localStorage.getItem("userLocation")).lat,
          lng: JSON.parse(localStorage.getItem("userLocation")).lng
        });
      }
    },
  },
  beforeMount() {
    if (window.innerWidth < 992) {
      this.setResponsive(true);
    }
  },

  mounted() {
    window.addEventListener("resize", () => {
      if (window.innerWidth < 992) {
        this.setResponsive(true);
      } else {
        this.setResponsive(false);
      }
    });
  },
};
</script>